export default __webpack_public_path__ + "static/media/arrowRight.0b4e16f8.svg";